import * as React from 'react'
// import './styles.scss';

import { FileProps } from '../../ImportFileFieldWithoutSaveButton'
import { Box, IconButton, Typography } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { useLang } from '~/hooks/useLang'
import { truncateText } from '~/utils/strings'


interface EntryImportFileFieldListProps {
  readonly file: FileProps
  readonly onDelete: (name: string) => void
}

export function EntryImportFileFieldList({
  file,
  onDelete,
}: EntryImportFileFieldListProps) {
  const { name, readableSize, type } = file
  const { translate } = useLang()

  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      justifyContent={'space-between'}
      flexDirection={'row'}
      width="100%"
      my={1}
    >
      <Box>
        <Typography variant="subtitle1" sx={{ wordBreak: 'break-all' }}>
          {`${translate('Name')}: ${truncateText(name, 20)}`}
        </Typography>

        <Typography variant="subtitle1">
          {`${translate('Size')}: ${readableSize}`}
        </Typography>

        <Typography variant="subtitle1">
          {`${translate('Type')}: ${type}`}
        </Typography>
      </Box>
      <IconButton onClick={() => onDelete(name)} color="error">
        <DeleteIcon />
      </IconButton>
    </Box>
  )
}
